<template>
<div class="sa-content">
    <div class="sa-card-large">
        <div class="sa-mob-header">
            <h5 class="sa-card-tit">Families</h5>
            <button class="sa-btn-back" @click="$router.go(-1)">
                <i class="icon-arrow-left"></i>
            </button>
        </div>
        <div class="sa-mob-cont">
            <div class="sa-patient-user" v-for="familyDetail in familyDetails" :key="familyDetail.id">
                <FamilyPatientsProfile :familyList="familyDetail" class="sa-fa-profile" />
            </div>
        </div>
        <img src="../../assets/img/loader.svg" alt="loader" class="sa-loader sa-loader-top" v-if="loader" />
        <h5 class="sa-text-center" v-else-if="!familyDetails.length">No data found</h5>
    </div>
</div>
</template>

<script>
import {
    family_url
} from "../../../config/endpoints";
import FamilyPatientsProfile from "../../components/familydoctors/FamilyPatientsProfile.vue";
export default {
    components: {
        FamilyPatientsProfile
    },
    data() {
        return {
            familyDetails: [],
            loader: false
        }
    },
    mounted() {
        this.familyData()
    },
    methods: {
        familyData() {
            let _self = this
            _self.loader = true
            _self.$store.dispatch("httpPost", {
                uri: `${family_url}/subscriber`
            }).then((response) => {
                console.log('response', response)
                if (response && response.status == 1000) {
                    _self.loader = false
                    _self.familyDetails = response.data
                } else {
                    _self.loader = false
                    _self.$store.dispatch("SET_ALERTMESSAGE", {
                        msg: "Something went wrong",
                        class: "sa-a-danger"
                    });
                }
            })
        }
    },
}
</script>

<style>
.sa-fa-profile{
    background-color: #FFFFFF;
    box-shadow: 0 0 20px 0 rgba(0,0,0,0.08), 0 0 10px 6px rgba(197,197,197,0.1);
}
.sa-patient-user .sa-badge-line {
    display: none;
}


.sa-upcoming {
    text-align: right;
    color: #30B400;
    font-size: 10px;
}
</style>
